<template>
  <UIInputText
    ref="input"
    v-model="modelValue"
    :autocomplete="autocomplete"
    left-icon="search"
    :name="name"
    :label="label"
    clearable
    class="input-search"
    :controlled="controlled"
    :placeholder="placeholder"
    :sync-v-model="syncVModel"
    :compact="compact"
    type="search"
    enterkeyhint="search"
    @keydown.enter="emit('search', modelValue as string)"
    @clear="emit('search', '')"
  ></UIInputText>
</template>

<script setup lang="ts">
import type { UIInputText } from '#build/components'
import type { InputTextProps } from '@/types/ui'

defineProps<InputTextProps>()

const modelValue = defineModel<InputTextProps['modelValue']>('modelValue')

const emit = defineEmits<{
  (e: 'search', value: string): void
  (e: 'search:debounced', value: string): void
}>()

const input = ref<InstanceType<typeof UIInputText> | null>(null)

defineExpose({ input })

watchDebounced(
  modelValue,
  () => {
    emit('search:debounced', typeof modelValue.value === 'string' ? modelValue.value?.toLowerCase() : modelValue.value)
  },
  { debounce: 500 },
)
</script>

<style scoped lang="scss">
.input-search {
  :deep() {
    &::-webkit-search-decoration,
    &::-webkit-search-cancel-button,
    &::-webkit-search-results-button,
    &::-webkit-search-results-decoration {
      display: none;
    }
  }
}
</style>
